import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {TransportesModel} from "./transportes.model";
import {TransportesService} from './transportes.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";

@Component({
  selector: 'app-transportes-form',
  templateUrl: './transportes-form.component.html'
})
export class TransportesFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  transporte: TransportesModel = new TransportesModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  id_transporte: string = '';
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private transportesService: TransportesService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_transporte: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(45)
      ]],
      tipo: ['', [
        Validators.required
      ]],
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_transporte'];

      this.id_transporte = id;

      if(!this.pageIsUpd){
        this.title = this.func.traduzir('front.editarTransporte');
      }else{
        this.title = id ? this.func.traduzir('front.visualizarTransporte') : this.func.traduzir('front.cadastrarNovoTransporte');
      }

      if (!id) {
        return;
      }

      this.transportesService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.title = this.func.traduzir('front.editarTransporte')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarTransporte') + ': ' + json.Payload[0].nome;
            }
            this.transporte = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.transporte; //this.form.value;

    if (values.id_transporte) {
      result = this.transportesService.editar(values, values.id_transporte);
    } else {
      result = this.transportesService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'transportes']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/transportes/transportes-form.component.ts